import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import 'react';

const LargeService = ({ testId, className, solid })=>{
    return /*#__PURE__*/ jsx("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        className: className,
        children: solid ? /*#__PURE__*/ jsxs(Fragment, {
            children: [
                /*#__PURE__*/ jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M5.19064 7.43677C5.96237 4.48128 8.72934 2.30005 11.9733 2.30005C15.8 2.30005 18.9666 5.34218 18.9666 9.10877V13.0508C18.9666 15.7937 17.2836 18.1541 14.8969 19.2316L14.8951 19.2324C14.5956 19.3666 14.2833 19.4824 13.9629 19.576L13.5704 18.2322C13.8274 18.1571 14.0793 18.0638 14.3217 17.9552C16.2456 17.0863 17.5666 15.2012 17.5666 13.0508V9.10877C17.5666 6.15464 15.0666 3.70005 11.9733 3.70005C8.8754 3.70005 6.37669 6.1548 6.37669 9.10877V14.5999C6.37669 14.9865 6.06329 15.2999 5.67669 15.2999H4.90791C3.94766 15.2954 3.02994 14.9064 2.35465 14.2206C1.67965 13.5351 1.30149 12.6088 1.30005 11.6444V11.0922C1.30149 10.1279 1.67965 9.20159 2.35465 8.51606C3.02994 7.83024 3.94766 7.44121 4.90791 7.43678L4.91114 7.43677L5.19064 7.43677Z",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M9.45752 19.158C9.45777 17.7648 10.5732 16.6168 11.9708 16.6168C13.3687 16.6168 14.4842 17.765 14.4842 19.1584C14.4842 20.5516 13.37 21.7001 11.9708 21.7001L11.9695 21.7001C11.2995 21.6988 10.6592 21.4282 10.1888 20.9505C9.71887 20.4731 9.45681 19.8283 9.45752 19.158Z",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M17.7695 7.64389C17.9009 7.51126 18.0799 7.43665 18.2667 7.43665H19.0924C20.0524 7.44144 20.9699 7.83057 21.645 8.51626C22.3199 9.20166 22.6982 10.1277 22.7 11.0918L22.7 11.0931L22.7 11.6459C22.6978 12.6099 22.3194 13.5355 21.6445 14.2206C20.9694 14.906 20.0522 15.2949 19.0924 15.2997L19.0889 15.2997L18.3244 15.2997C17.9403 15.2997 17.6279 14.9901 17.6245 14.606L17.5667 8.1429C17.565 7.95617 17.638 7.77652 17.7695 7.64389Z",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M10.2891 11.5251C10.1324 11.5243 9.9824 11.4608 9.87171 11.3485C9.76101 11.2362 9.69858 11.0842 9.698 10.9255V10.2393C9.698 9.90965 9.96466 9.63965 10.2902 9.63965C10.6158 9.63965 10.8824 9.90965 10.8824 10.2393V10.9255C10.8824 11.2551 10.6158 11.5251 10.2902 11.5251M13.1924 11.5251C13.0355 11.5245 12.8852 11.4612 12.7743 11.3489C12.6634 11.2365 12.6008 11.0844 12.6002 10.9255V10.2393C12.6002 9.90965 12.8669 9.63965 13.1924 9.63965C13.518 9.63965 13.7846 9.90965 13.7846 10.2393V10.9255C13.7846 11.2551 13.518 11.5251 13.1924 11.5251Z",
                    fill: "currentColor"
                })
            ]
        }) : /*#__PURE__*/ jsxs(Fragment, {
            children: [
                /*#__PURE__*/ jsx("path", {
                    d: "M13.7666 18.904C14.0555 18.8197 14.3377 18.7151 14.6088 18.5936C16.7643 17.6204 18.2665 15.4976 18.2665 13.0507V9.10872C18.2665 5.74836 15.4332 3 11.9733 3C8.50884 3 5.67664 5.74836 5.67664 9.10872V14.5998H4.91109C4.13857 14.5963 3.39882 14.2833 2.85339 13.7294C2.30796 13.1755 2.00117 12.4255 2 11.6433V11.0932C2.00117 10.311 2.30796 9.56108 2.85339 9.00714C3.39882 8.45321 4.13857 8.14029 4.91109 8.13673H5.73331",
                    stroke: "currentColor",
                    strokeWidth: "1.4",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M13.7841 19.1584C13.7841 20.1754 12.973 21 11.9708 21C11.4892 20.9991 11.0277 20.8046 10.6876 20.4593C10.3476 20.1139 10.1569 19.646 10.1575 19.1584C10.1575 18.1414 10.9697 17.3168 11.9708 17.3168C12.9719 17.3168 13.7841 18.1414 13.7841 19.1584Z",
                    stroke: "currentColor",
                    strokeWidth: "1.4",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M18.2667 8.1366H19.0889C19.8614 8.14046 20.601 8.45347 21.1463 9.00734C21.6917 9.56121 21.9986 10.311 22 11.0931V11.6443C21.9983 12.4262 21.6913 13.1757 21.1459 13.7293C20.6006 14.283 19.8612 14.5958 19.0889 14.5997H18.3245",
                    stroke: "currentColor",
                    strokeWidth: "1.4",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M10.2891 11.5251C10.1324 11.5243 9.98237 11.4608 9.87168 11.3485C9.76098 11.2362 9.69855 11.0842 9.69797 10.9255V10.2393C9.69797 9.90965 9.96463 9.63965 10.2902 9.63965C10.6157 9.63965 10.8824 9.90965 10.8824 10.2393V10.9255C10.8824 11.2551 10.6157 11.5251 10.2902 11.5251M13.1924 11.5251C13.0355 11.5245 12.8852 11.4612 12.7743 11.3489C12.6633 11.2365 12.6008 11.0844 12.6002 10.9255V10.2393C12.6002 9.90965 12.8668 9.63965 13.1924 9.63965C13.5179 9.63965 13.7846 9.90965 13.7846 10.2393V10.9255C13.7846 11.2551 13.5179 11.5251 13.1924 11.5251Z",
                    fill: "currentColor"
                })
            ]
        })
    });
};

export { LargeService as default };
